import angular from 'angular'

import deline from '../utils/deline'

import { wrap, assign, lowerCase, upperFirst } from 'lodash-es'

/* dirty hack to assign up to six ggs-element-position directives to one element */

const MODULE_NAME = 'ggs.element-position'
const BASE_DIRECTIVE_NAME = 'ggsElementPosition'

registerDirective()
registerDirective('Alpha')
registerDirective('Bravo')
registerDirective('Charlie')
registerDirective('Delta')
registerDirective('Echo')
registerDirective('Foxtrot')

function registerDirective(suffix = '') {
  const directiveName = BASE_DIRECTIVE_NAME + upperFirst(lowerCase(suffix))
  const directiveProvider = makeDirective(directiveName)
  return angular.module(MODULE_NAME).directive(directiveName, directiveProvider)
}

function makeDirective(directiveName) {

  const queryAttrName = directiveName
  const emitterAttrName = directiveName + 'Emitter'

  return function ElementPositionProvider(
    $parse,
    applyAsync,
    ElementPositionInternal) {

    'ngInject'

    return {
      restrict: 'A',
      priority: 400,
      link: {
        pre: preLink
      }
    }

    function preLink($scope, $elm, $attr) {
      const format = /^(.+?)=(.+)$/
      const input = $attr[queryAttrName].replace(/(\d+)px/g, '$1')
      const match = format.exec(input)

      const queryAttr = deline(match[2])

      const modelAttr = deline(match[1])
      const emitterAttr = deline($attr[emitterAttrName])

      const ngQuery = $parse(queryAttr)
      const ngModel = $parse(modelAttr)
      const ngEmitter = $parse(emitterAttr)

      const get = wrap($scope, ngModel)
      const set = wrap($scope, ngModel.assign)
      const query = assign(wrap($scope, ngQuery), { info: `[Directive: ${queryAttr}]` })
      const optionalEmitter = ngEmitter($scope)

      const callback = (result) => {
        if (result === get()) {
          return
        }

        if (optionalEmitter) {
          set(result)
          optionalEmitter.emit(result)
        } else {
          applyAsync($scope, set, result)
        }
      }

      const elementPosition = ElementPositionInternal($elm, query, callback)
      $scope.$on('$destroy', elementPosition.destroy)
    }
  }
}
